// extracted by mini-css-extract-plugin
export const plainHeaderWrapper = "plain-header-module--plain-header-wrapper--3wvIQ";
export const logoContainer = "plain-header-module--logo-container--Vejai";
export const plainHeaderTransparent = "plain-header-module--plain-header-transparent--rMfA3";
export const dark = "plain-header-module--dark--3I7Av";